import { useMemo, useState } from "react";
import useDebounce from "utilities/hooks/use-debounce";

interface UseScrollDirectionOptions {
    isEnabled?: boolean;
}

export enum ScrollDirection {
    Unknown = 0,
    Up = 1,
    Down = 2,
}

const SCROLL_TOLERANCE = 10;

const useScrollDirection = (options: UseScrollDirectionOptions) => {
    const { isEnabled = true } = options;
    const [scrollDirection, setScrollDirection] = useState<ScrollDirection>();
    const [lastScrollY, setLastScrollY] = useState();

    const lastScrollYDebounced = useDebounce(lastScrollY, 200);

    const hasScrolledDown = useMemo(
        () => scrollDirection === ScrollDirection.Down,
        [scrollDirection]
    );
    const hasScrolledUp = useMemo(
        () => scrollDirection === ScrollDirection.Up,
        [scrollDirection]
    );

    const handleScroll = (e) => {
        if (!isEnabled) {
            return;
        }
        const scrollY = e.target.scrollTop;
        const direction =
            !lastScrollYDebounced || scrollY > lastScrollYDebounced
                ? ScrollDirection.Down
                : ScrollDirection.Up;
        if (
            direction !== scrollDirection &&
            (scrollY - (lastScrollYDebounced ?? 0) > SCROLL_TOLERANCE ||
                scrollY - (lastScrollYDebounced ?? 0) < -1 * SCROLL_TOLERANCE)
        ) {
            setScrollDirection(direction);
        }
        setLastScrollY(scrollY);
    };

    return {
        handleScroll,
        scrollDirection,
        hasScrolledDown,
        hasScrolledUp,
    };
};

export default useScrollDirection;
